export default __webpack_public_path__ + "static/media/variant.6b406a0b.svg";